export default __webpack_public_path__ + "static/media/29_mobile.8c03280f.jpg";